<p>reset-link-redirect works!</p>
